import JwtService from "@/libraries/JWTService";

const jwt = new JwtService()

export default jwt